import React, { Component } from 'react'
import { connect } from 'react-redux'
import { forEach, head, get, map, keys, split, size } from 'lodash'
import { adminContactRoleList, invalidateContactRoleLists } from './actions/admin_contact_role'
import { Separator } from 'components/layout/Separator'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import {showSuccess, showError} from 'actions/Error'
import { handleSubmitResult } from 'actions/form'
import AdminCommonFormLayout from '../layout/AdminCommonFormLayout'
import { FormikInputField } from 'components/form/InputField'
import AdminContactRoleForm from './form/AdminContactRoleForm'
import { validationSchema } from './form/AdminContactRoleForm'

class AdminContactRole extends Component {

    componentDidMount() {
        const { dispatch, contact_role_id } = this.props
        dispatch(adminContactRoleList.ensureObjectLoaded(contact_role_id))
    }

    componentDidUpdate(prev_props) {
        const { dispatch, contact_role_id } = this.props
        dispatch(adminContactRoleList.ensureObjectLoaded(contact_role_id))
    }

    onSave = (values, formik_funcs) => {
        const { history, onSubmit, dispatch, contact_role_id } = this.props

        const on_ok = function(json) {
            dispatch(invalidateContactRoleLists())
            showSuccess("Saved", "Contact Role saved")

            if ( ! contact_role_id ) {
                history.push(`/admin/contact_role/${json.id}`)
            }
        }
        if ( contact_role_id ) {
            values.id = contact_role_id
            return dispatch(adminContactRoleList.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminContactRoleList.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }

    getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            default:
                return undefined
        }
    }

    render() {
        const { initial_values, is_loading, is_busy, contact_role, contact_role_id } = this.props
        const that = this
        const title = `${get(contact_role, "name", 'New contact role')}`

        return (
            <AdminCommonFormLayout breadcrumbs={[{name: 'admin_home'},

                                                 {name: 'contact_roles',
                                                  label: 'Contact Roles',
                                                  url: '/admin/contact_roles'},

                                                 {name: 'contact_role',
                                                  label: get(contact_role, "name", 'New contact role'),
                                                  url: `/admin/contact_roles/${contact_role_id}`
                                                 }
                                                ]}
                                   is_busy={is_busy}
                                   is_loading={is_loading}
                                   title={title}
                                   initial_values={initial_values}
                                   validationSchema={validationSchema}
                                   onSave={this.onSave}>

              {
                  ({formik_props}) => <AdminContactRoleForm formik_props={formik_props} />
              }
            </AdminCommonFormLayout>
        )
    }

}

function mapStateToProps(state, props) {
    const contact_role_id = get(props, ["match", "params", "contact_role_id"], null)
    const contact_role = adminContactRoleList.getObject(contact_role_id)

    return {
        contact_role_id,
        contact_role,
        is_loading: adminContactRoleList.isLoading() || (contact_role_id && !get(contact_role, "id")),
        is_busy: adminContactRoleList.getIsSavingObject(),
        initial_values: contact_role
    }
}

export default connect(mapStateToProps)(AdminContactRole)
